import { Swiper } from "swiper";
import "swiper/css";

window.swiperInstances = window.swiperInstances || [];

document.addEventListener('DOMContentLoaded', () => {
    const swiperContainers = document.querySelectorAll('.swiper')

    swiperContainers.forEach(slider => {
        const swiper = new Swiper(slider, {
            spaceBetween: 16,
            slidesPerView: 'auto',
            breakpoints: {
                768: {
                    spaceBetween: 50
                }
            }
        })

        swiperInstances.push(swiper)
    })
})